import { render, staticRenderFns } from "./ClientsForm.vue?vue&type=template&id=276eed52&"
import script from "./ClientsForm.vue?vue&type=script&lang=ts&"
export * from "./ClientsForm.vue?vue&type=script&lang=ts&"
import style0 from "./ClientsForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports